import firebase from 'firebase';

const {
    REACT_APP_DEV,


    REACT_APP_FIREBASE_API_KEY,
    REACT_APP_AUTH_DOMAIN,
    REACT_APP_DATABASE_URL,
    REACT_APP_PROJECT_ID,
    REACT_APP_STORAGE_BUCKET,
    REACT_APP_MESSAGING_SENDER_ID,
    REACT_APP_APP_ID,
    REACT_APP_MEASUREMENT_ID,

    REACT_APP_FIREBASE_API_KEY_DEV,
    REACT_APP_AUTH_DOMAIN_DEV,
    REACT_APP_DATABASE_URL_DEV,
    REACT_APP_PROJECT_ID_DEV,
    REACT_APP_STORAGE_BUCKET_DEV,
    REACT_APP_MESSAGING_SENDER_ID_DEV,
    REACT_APP_APP_ID_DEV,
    REACT_APP_MEASUREMENT_ID_DEV,
 

    REACT_APP_FIREBASE_API_KEY_DEV_TL,
    REACT_APP_AUTH_DOMAIN_DEV_TL,
    REACT_APP_PROJECT_ID_DEV_TL,
    REACT_APP_STORAGE_BUCKET_DEV_TL,
    REACT_APP_MESSAGING_SENDER_ID_DEV_TL,
    REACT_APP_APP_ID_DEV_TL,
    REACT_APP_MEASUREMENT_ID_DEV_TL,


    REACT_APP_FIREBASE_API_KEY_TL,
    REACT_APP_AUTH_DOMAIN_TL,
    REACT_APP_PROJECT_ID_TL,
    REACT_APP_STORAGE_BUCKET_TL,
    REACT_APP_MESSAGING_SENDER_ID_TL,
    REACT_APP_APP_ID_TL,
    REACT_APP_MEASUREMENT_ID_TL,

} = process.env;

let firebaseConfig = {}


if(REACT_APP_DEV === "DEV_WHATS2B"){
            firebaseConfig = {
            apiKey: REACT_APP_FIREBASE_API_KEY_DEV,
            authDomain: REACT_APP_AUTH_DOMAIN_DEV,
            databaseURL: REACT_APP_DATABASE_URL_DEV,
            projectId: REACT_APP_PROJECT_ID_DEV,
            storageBucket: REACT_APP_STORAGE_BUCKET_DEV,
            messagingSenderId: REACT_APP_MESSAGING_SENDER_ID_DEV,
            appId: REACT_APP_APP_ID_DEV,
            measurementId: REACT_APP_MEASUREMENT_ID_DEV,
        };

}

if(REACT_APP_DEV === "PROD_WHATS2B"){
    firebaseConfig = {
        apiKey: REACT_APP_FIREBASE_API_KEY,
        authDomain: REACT_APP_AUTH_DOMAIN,
        databaseURL: REACT_APP_DATABASE_URL,
        projectId: REACT_APP_PROJECT_ID,
        storageBucket: REACT_APP_STORAGE_BUCKET,
        messagingSenderId: REACT_APP_MESSAGING_SENDER_ID,
        appId: REACT_APP_APP_ID,
        measurementId: REACT_APP_MEASUREMENT_ID,   
    }  
    
  

}


if(REACT_APP_DEV === "DEV_CHAT2B"){
    firebaseConfig = {
        apiKey: REACT_APP_FIREBASE_API_KEY_DEV_TL,
        authDomain: REACT_APP_AUTH_DOMAIN_DEV_TL,
        databaseURL: "",
        projectId: REACT_APP_PROJECT_ID_DEV_TL,
        storageBucket: REACT_APP_STORAGE_BUCKET_DEV_TL,
        messagingSenderId: REACT_APP_MESSAGING_SENDER_ID_DEV_TL,
        appId: REACT_APP_APP_ID_DEV_TL,
        measurementId: REACT_APP_MEASUREMENT_ID_DEV_TL,   
    }   
} 




if(REACT_APP_DEV === "PROD_CHAT2B"){
    firebaseConfig = {
        apiKey: REACT_APP_FIREBASE_API_KEY_TL,
        authDomain: REACT_APP_AUTH_DOMAIN_TL,
        databaseURL: "",
        projectId: REACT_APP_PROJECT_ID_TL,
        storageBucket: REACT_APP_STORAGE_BUCKET_TL,
        messagingSenderId: REACT_APP_MESSAGING_SENDER_ID_TL,
        appId: REACT_APP_APP_ID_TL,
        measurementId: REACT_APP_MEASUREMENT_ID_TL,   
    }   
} 





export const firebase_app = firebase.initializeApp(firebaseConfig);